import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { NewAccountStackRoutes, NewAccountStackScreenProps } from './type';
import { NewAccountWebTwoScreen } from './NewAccountWebTwo.screen';
import { NewAccountNativeTwoScreen } from './NewAccountNativeTwo.screen';

export interface NewAccountProps {}
export const NewAccountPlaced: React.FC<NewAccountStackScreenProps<NewAccountStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, returnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <NewAccountNativeTwoScreen onClose={onGoBack} data={data} returnData={returnData} refresh={refresh} />;
  }

  return <NewAccountWebTwoScreen onClose={closeModal} onLayout={onLayout} data={data} returnData={returnData} refresh={refresh} />;
};
